module.exports = __webpack_public_path__ + "img/kristina.98c6711b.png";